var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-card',{attrs:{"title":"服务调用历史"}},[_c('search',{on:{"searchChange":_vm.handleSearchChange}}),_c('mtable',{style:({width:_vm.tableWidth}),attrs:{"searchD":_vm.searchD}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }